import useGetActivityWorkloadLevel from '~/bootcamp/hooks/useGetActivityWorkloadLevel'
import useGetAvailableRewards from '~/bootcamp/hooks/useGetAvailableRewards'
import useGetCollectedRewards from '~/bootcamp/hooks/useGetCollectedRewards'
import useGetCurrentDifficultyLevel from '~/bootcamp/hooks/useGetCurrentDifficultyLevel'
import { useGetRewardsInChest } from '~/bootcamp/hooks/useGetRewardsInChest'
import { selectBootcampActivityEvents, selectCurrentActivityType } from '~/bootcamp/slices/bootcamp-activity.slice'
import { selectBootcampPageActivities } from '~/bootcamp/slices/bootcamp-page.slice'
import { selectVccComplexityLevel } from '~/bootcamp/slices/vcc-data.slice'
import { BootcampActivitySet } from '~/bootcamp/types/bootcamp.types'
import { getXPCountInChest } from '~/bootcamp/utils/bootcamp.utils'
import { useAppSelector } from '~/redux/hooks'

export const useGetActivityReward = (): { gems: number; xp: number; kudos: number } => {
  const events = useAppSelector(selectBootcampActivityEvents)
  const activities = useAppSelector(selectBootcampPageActivities) || []
  const bootcampComplexityLevel = useAppSelector(selectVccComplexityLevel) || 1
  const activityWorkloadLevel = useGetActivityWorkloadLevel(activities)
  const [difficultyLevel] = useGetCurrentDifficultyLevel(events, activities)

  const collectedRewards = useGetCollectedRewards(events)
  const availableRewards = useGetAvailableRewards(activities)

  const activityType = useAppSelector(selectCurrentActivityType)
  const currentActivitySet = activities.find((elem) => elem.type === activityType)

  const isAtLastDifficultyLevel = collectedRewards + 1 === availableRewards

  const rewardsForChest = useGetRewardsInChest(
    currentActivitySet as unknown as BootcampActivitySet,
    bootcampComplexityLevel,
  )

  if (isAtLastDifficultyLevel) {
    return rewardsForChest
  }

  return {
    xp: Math.round(getXPCountInChest(bootcampComplexityLevel, activityWorkloadLevel, difficultyLevel) * 0.75),
    gems: 0,
    kudos: 0,
  }
}
